import store from "../store";
import Constants from "../config/constants";
import { serviceGetPrimaryUserUpdateList } from "../services/PrimaryUserUpdate.service";

export const FETCH_INIT = "FETCH_INIT_PRIMARY_USER_UPDATE_LIST";
export const FETCHED = "FETCHED_PRIMARY_USER_UPDATE_LIST";
export const FETCHED_FAIL = "FETCHED_FAIL_PRIMARY_USER_UPDATE_LIST";
export const FETCHED_FILTER = "FETCHED_FILTER_PRIMARY_USER_UPDATE_LIST";
export const FETCH_NEXT = "FETCH_NEXT_PRIMARY_USER_UPDATE_LIST";
export const FILTER = "FILTER_PRIMARY_USER_UPDATE_LIST";
export const RESET_FILTER = "RESET_FILTER_PRIMARY_USER_UPDATE_LIST";
export const SET_SORTING = "SET_SORTING_PRIMARY_USER_UPDATE_LIST";
export const SET_FILTER = "SET_FILTER_PRIMARY_USER_UPDATE_LIST";
export const SET_PAGE = "SET_PAGE_PRIMARY_USER_UPDATE_LIST";
export const CHANGE_PAGE = "CHANGE_PAGE_PRIMARY_USER_UPDATE_LIST";
export const CHANGE_STATUS = "CHANGE_STATE_PRIMARY_USER_UPDATE_LIST";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_PRIMARY_USER_UPDATE_LIST";
export const CREATE_DATA = "CREATE_PRIMARY_USER_UPDATE_LIST";
export const UPDATE_DATA = "UPDATE_PRIMARY_USER_UPDATE_LIST";
export const DELETE_ITEM = "DELETE_PRIMARY_USER_UPDATE_LIST";

export function actionFetchPrimaryUserUpdateList(
  index = 1,
  sorting = {},
  filter = {}
) {
  const request = serviceGetPrimaryUserUpdateList({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionChangePagePrimaryUserUpdateList(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterPrimaryUserUpdateList(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); 
    });
  };
}
export function actionResetFilterVendor() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPagePrimaryUserUpdateList(page) {
  const stateData = store.getState().primary_user_update;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchPrimaryUserUpdateList(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  console.log(currentPage, totalLength);
  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
